export const SLIDER_SPACE_BETWEEN = 16;
export const SLIDER_SPACE_BETWEEN_ACTIVITY = 16;

export const BASE_STORAGE = 5120;
export const PROGRESS_DELAY = 10;

export const POPOVER_MARGIN = 10;

export const MAX_ACTIVITY_X_AXIS = 1000;

export const IS_SHOW_EVENT_MODAL = false;

export const ERROR_CODES = {
  STORAGE_EXCEEDED: '400',
} as const;

export const TIME_CHART_CONFIG = {
  SEGMENT_ANGLE: 360 / 12,
  RADIUS: 93.5,
  LABEL_RADIUS: 120,
  CENTER_X: 93.5,
  CENTER_Y: 93.5,
  OFFSET_X: 2,
  OFFSET_Y: 8,
};

export const BAR_CHART_CONFIG = {
  THRESHOLDS: [
    { maxVal: 400, yMax: 800, yStep: 200 },
    { maxVal: 200, yMax: 400, yStep: 100 },
    { maxVal: 100, yMax: 200, yStep: 50 },
  ],
  DEFAULT: { yMax: 100, yStep: 25 },
  GRID_LINE_COUNT: 5,
};

export const DATA_STATUS = {
  NORMAL: 1,
  LOADING: 2,
  ERROR: 3,
  NO_DATA: 4,
} as const;

